import React, { useContext } from "react";
import HamburgerIcon from "./icons/HamburgerIcon.jsx";
import PlatformContext from "./PlatformContext.jsx";
import SiteContext from "./SiteContext.jsx";

export default function Banner() {
  const { platform, chromeHeight } = useContext(PlatformContext);
  const { backgroundImageUrl } = useContext(SiteContext);

  return (
    <div className='tw-relative'>
      <div
        className={`
          tw-absolute
          tw-left-5
          tw-top-[var(--offset)]
          ${platform === "android" ? "tw-mt-5" : "tw-mt-3"}
        `}
        style={{ "--offset": `${chromeHeight}px` } as React.CSSProperties}
      >
        <HamburgerIcon className='tw-h-8 tw-w-8 tw-fill-white' />
      </div>

      <img
        src={backgroundImageUrl}
        alt=''
        className='
          tw-block
          tw-aspect-5/4
          tw-w-full
          tw-bg-[var(--primary-color,black)]
          tw-object-cover
          tw-object-center
        '
      />
    </div>
  );
}
